import {
  useNotificationsActionsContext,
  useNotificationsContext,
} from '../../services/notification/NotificationsProvider';

export const useNotifications = () => {
  const {
    notifications,
    loadingNotifications,
    filters,
    pagination,
    sort,
    notViewedCount,
  } = useNotificationsContext();
  return {
    notifications,
    notViewedCount,
    loadingNotifications,
    filters,
    pagination,
    sort,
  };
};

export const useNotificationsActions = () => {
  const {
    handleFiltersChanged,
    handleFiltersReset,
    handlePageChanged,
    handlePageSizeChanged,
    handlePagingChanged,
    handleSortChanged,
    fetchNotifications,
    setFilters,
    getNotViewedNotificationsCount,
    setViewed,
  } = useNotificationsActionsContext();
  return {
    handleFiltersChanged,
    handleFiltersReset,
    handlePageChanged,
    handlePagingChanged,
    handlePageSizeChanged,
    handleSortChanged,
    fetchNotifications,
    setFilters,
    getNotViewedNotificationsCount,
    setViewed,
  };
};
